import type { FC } from 'react';

import { Alert, AlertDescription, Link } from '@vimeo/bokeh';
import { translate } from '@vimeo/i18n-runtime';

export const DrmAlert: FC = () => (
  <Alert status="warning" mb="md">
    <AlertDescription>
      {translate({
        singular:
          'Downloaded videos are not protected by digital rights management (DRM). {LINK}Learn more{/LINK}',
        replacements: {
          LINK: (text: string) => (
            <Link
              title={translate('Learn more')}
              target="_blank"
              href="https://vimeo.com/help/zendesk_sso?redirect_to=https://help.vimeo.com/hc/en-us/articles/31622243101969"
              key="learn-more-link"
            >
              {text}
            </Link>
          ),
        },
      })}
    </AlertDescription>
  </Alert>
);
